import { TEAM_MEMBERS } from '../data/content'

function TeamPage() {
    return (
        <div className="pt-28 bg-gradient-to-b from-white via-brand-blue-light/10 to-brand-blue-light/30 min-h-screen">
            {/* Team Hero Section */}
            <section className="relative py-20 px-4 overflow-hidden">
                {/* Background cloud blobs - same as AboutPage */}
                <svg
                    className="absolute -top-20 -right-32 w-[700px] h-[500px] text-brand-blue-light opacity-30 -z-10"
                    viewBox="0 0 200 150"
                    fill="currentColor"
                >
                    <ellipse cx="100" cy="80" rx="90" ry="60" />
                    <ellipse cx="60" cy="90" rx="50" ry="40" />
                    <ellipse cx="140" cy="85" rx="55" ry="45" />
                </svg>

                <div className="max-w-[1500px] mx-auto text-center px-6">
                    <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-brand-blue mb-8">
                        <span className="border-b-4 border-brand-blue pb-2">OUR TEAM</span>
                    </h1>
                    <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto">
                        Dedicated educators, engineers, and advocates working together to make a difference in computer science education.
                    </p>
                </div>
            </section>

            {/* Team Grid Section */}
            <section className="relative py-20 px-4 overflow-hidden">
                {/* Decorative elements */}
                <div className="absolute left-10 top-1/4 hidden lg:block">
                    <div className="w-16 h-16 rounded-full border-2 border-brand-blue opacity-20"></div>
                </div>
                <div className="absolute right-10 bottom-1/4 hidden lg:block">
                    <svg className="w-12 h-12 text-brand-blue opacity-20" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                </div>

                <div className="max-w-[1500px] mx-auto px-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12 mt-12">
                        {TEAM_MEMBERS.map((member, index) => (
                            <div key={index} className="flex flex-col items-center bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow group">
                                <div className="relative mb-6">
                                    {/* Outer circle border */}
                                    <div className="absolute inset-0 rounded-full border-2 border-brand-blue opacity-20 scale-110 group-hover:scale-125 transition-transform duration-300"></div>

                                    {/* Photo Container */}
                                    <div className="w-40 h-40 rounded-full overflow-hidden bg-gradient-to-br from-gray-100 to-brand-blue-light/10 shadow-inner">
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                </div>

                                <h3 className="text-xl font-heading font-bold text-gray-800 mb-2">{member.name}</h3>
                                <p className="text-brand-blue font-semibold text-center">{member.role}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 px-4">
                <div className="max-w-[1000px] mx-auto bg-brand-blue rounded-3xl p-12 text-center text-white shadow-2xl relative overflow-hidden">
                    {/* Decorative SVG in CTA */}
                    <svg className="absolute -right-10 -top-10 w-40 h-40 opacity-10" fill="currentColor" viewBox="0 0 100 100">
                        <circle cx="50" cy="50" r="40" />
                    </svg>

                    <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">Join Our Team</h2>
                    <p className="text-lg opacity-90 mb-10 max-w-2xl mx-auto">
                        We're always looking for passionate individuals who want to make a difference in computer science education.
                    </p>
                    <a href="/get-involved" className="btn btn-primary rounded-full px-12">
                        GET INVOLVED
                    </a>
                </div>
            </section>
        </div>
    )
}

export default TeamPage
